import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DetailsDataService} from '../../../details.data.service';
import {UnmatchedRecordsService} from '../../../../../unmatched-records/unmatched-records.service';

// tslint:disable-next-line:interface-name
export interface DialogData {
  id: string;
  originalId: number;
  name: string;
  sourceType: string;
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'create-employee-dialog',
  templateUrl: './create-employee-dialog.html',
})
// tslint:disable-next-line:component-class-suffix
export class CreateEmployeeDialog {
  progress = false;
  constructor(
    public dialogRef: MatDialogRef<CreateEmployeeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    protected detailsDataService: DetailsDataService,
    private _snackBar: MatSnackBar,
    public unmatchedRecordsService: UnmatchedRecordsService) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.progress = true;
    this.unmatchedRecordsService
      .matchEmployee(null, this.data.id, 'NETSUITE', 'NETSUITE_EMPLOYEE', this.data.sourceType)
      .subscribe(
        r => {
          this.detailsDataService.changeMessage({id: 1, textLabel: 'Refresh Sync'});
          this._snackBar.open('Employee \'' + this.data.name + '\' successfully matched!', 'Close', {
            duration: 5000,
          });
          this.progress = true;
          this.dialogRef.close();
        },
        error => {
          this.progress = true;
          console.log(error);
        });
  }
}
